export function base64ToArrayBuffer(b64str) {
  let byteStr = atob(b64str);
  let bytes = new Uint8Array(byteStr.length);
  for (let i = 0; i < byteStr.length; i++) {
    bytes[i] = byteStr.charCodeAt(i);
  }
  return bytes.buffer;
}
